import React, { useEffect, useState } from "react";
import { useEspelhoVendas } from "services/api/AppWeb_EspelhoVendas";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  mutate: any;
  refetch: () => void;
  reset1: () => void;
  isLoading: boolean;
  isSuccess: boolean;
}

const ResetarFluxoModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        onClose={() => props?.onClose()}
        mutate={props?.mutate}
        refetch={props?.refetch}
        reset1={props?.reset1}
        isLoading={props?.isLoading}
        isSuccess={props?.isSuccess}
      />
    </Styles.Container>
  );
};

export default ResetarFluxoModal;
